// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"1c45ecd3","36":"50d6daac","279":"c028cc86","283":"fe553026","368":"1c45ecd3","639":"c028cc86","923":"90a48b58","979":"50d6daac"}[chunkId] + ".css";
};